import { render, staticRenderFns } from "./COriginalClass.vue?vue&type=template&id=5ed9b887&scoped=true"
import script from "./COriginalClass.vue?vue&type=script&lang=js"
export * from "./COriginalClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed9b887",
  null
  
)

export default component.exports